import { createSlice } from "@reduxjs/toolkit";
import { cardApi } from "./card.api";
// Api response type
const initialState = {
    loyaltyCard: {
        cardNumber: '',
        cardActivationDate: '',
        cardStatus: '',
        appleWallet: `${process.env.API_ENDPOINT}wallet-service/api/v1/wallet/apple` || '',
        googleWallet: ''
    },
    dictionary: {}
};
export const cardSlice = createSlice({
    name: "card",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addMatcher(cardApi.endpoints.getCard.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), { loyaltyCard: Object.assign(Object.assign({}, state.loyaltyCard), action.payload.loyaltyCard) });
        })
            .addMatcher(cardApi.endpoints.getGoogleWalletUrl.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), { loyaltyCard: Object.assign(Object.assign({}, state.loyaltyCard), { googleWallet: action.payload.url }) });
        });
    }
});
//# sourceMappingURL=card.slice.js.map